export default __webpack_public_path__ + "static/media/codercarl.46716a9b.png";